import type CK from '~/types/contentking';

import {
	useAccountOrganizationTeamsQuery,
} from './useAccountOrganizationTeams.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountOrganizationTeams(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountOrganizationTeamsQuery,
		accountId,
	);

	return data?.account?.organizationTeams ?? null;
}



export default useAccountOrganizationTeams;
